module.exports = __webpack_public_path__ + "img/9.1fd197a9.jpg";